// extracted by mini-css-extract-plugin
export default {"custom-toast":"Success_custom-toast__cnUCa","myCustomAnimation":"Success_myCustomAnimation__UR5WP"};